import React from 'react';
import { CampaignPage } from './components/campaign/CampaignPage';
export function App() {
  return <CampaignPage data-id="element-0" data-mp="35ctutf7sahha" />;
}